import React, { useEffect, useContext, useCallback } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import GroupsList from '../../../AddToGroupsPanel/_partials/GroupsList';
import { useAddToGroupFlow } from '../../../AddToGroupsPanel/useAddToGroupFlow';
import FolderList from '../../../AddToGroupsPanel/_partials/FolderList';
import SelectedGroupHeader from './SelectedGroupHeader';
import GroupSearchInput from './GroupSearchInput';
import s from './AddToGroupPopup.scss';
const AddToGroupPopup = ({ deviation, className, biData = {}, actionbarType, initGroupsPanel, addToGroupFolder, hasOnlyOneChunkOfGroupsToLoad, hasNoGroups, forceModal, onClose })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { selectGroup, selectedGroup, resetSelectedGroup, selectedSubmissionType, filterValue, onFilterInputChange } = useAddToGroupFlow();
    useEffect(()=>{
        initGroupsPanel();
    }, [
        initGroupsPanel
    ]);
    const onFolderSelected = useCallback((folderId)=>{
        if (!selectedGroup) {
            return;
        }
        addToGroupFolder(deviation, selectedGroup, {
            groupId: selectedGroup.userId,
            type: selectedSubmissionType,
            folderId
        }, actionbarType, biData);
        setTimeout(()=>{
            onClose && onClose();
        }, 1000); // to show state change (folder becoming checked in the list) for the user
    }, [
        actionbarType,
        addToGroupFolder,
        deviation,
        biData,
        onClose,
        selectedGroup,
        selectedSubmissionType
    ]);
    const showSearch = !selectedGroup && !hasNoGroups && hasOnlyOneChunkOfGroupsToLoad;
    const preamble = /*#__PURE__*/ React.createElement(React.Fragment, null, showSearch && /*#__PURE__*/ React.createElement(GroupSearchInput, {
        className: s['filter-input'],
        filterValue: filterValue,
        onFilterInputChange: onFilterInputChange
    }));
    const content = /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: biData
    }, selectedGroup === undefined && /*#__PURE__*/ React.createElement(GroupsList, {
        deviationId: deviation.deviationId,
        filterValue: filterValue,
        onSelect: selectGroup
    }), selectedGroup && /*#__PURE__*/ React.createElement(FolderList, {
        deviationId: deviation.deviationId,
        groupId: selectedGroup.userId,
        submissionType: selectedSubmissionType,
        onFolderSelected: onFolderSelected
    }));
    if (isMobile || forceModal) {
        return /*#__PURE__*/ React.createElement(DSModal, {
            isOpen: true,
            heading: selectedGroup ? /*#__PURE__*/ React.createElement(SelectedGroupHeader, {
                group: selectedGroup,
                resetSelectedGroup: resetSelectedGroup
            }) : /*#__PURE__*/ React.createElement(React.Fragment, null, t('addToGroupPopup.title')),
            preamble: isMobile ? preamble : undefined,
            className: c(s['root'], !isMobile && s['forced-modal'], className),
            contentClassName: s['content-wrapper'],
            layoutClassName: c(!isMobile && s['forced-modal-layout']),
            withScrollableContentWrapper: true,
            onRequestClose: onClose
        }, isMobile ? undefined : preamble, content);
    }
    return /*#__PURE__*/ React.createElement(DSPopover, {
        heading: selectedGroup ? selectedGroup.username : t('addToGroupPopup.title'),
        className: c(s['root'], className),
        contentClassName: s['content-wrapper'],
        preamble: preamble,
        content: content,
        onCloseClick: onClose,
        onBackClick: selectedGroup ? resetSelectedGroup : undefined
    });
};
AddToGroupPopup.displayName = 'AddToGroupPopup';
export default AddToGroupPopup;

//# sourceMappingURL=AddToGroupPopup.js.map